module.exports = __webpack_public_path__ + "media/images/casier à ski-f3d38eb6442d0a1ec68bcdbf46410930.svg";